import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { ConditionalWrapper } from 'common/react/components/ConditionalWrapper';

export const DraftTrackerHeader = ({
    title,
    linkTo,
    isLinkInNewTab,
    promo
}) => {
    const sponsorText = promo?.title;
    const sponsorImage = promo?.promoItem?.onDemandUrl;
    const sponsorLink = promo?.links?.length ? promo.links[0].promoUrl : '';
    const isSponsorLinkInNewTab =
        (promo?.links?.length && promo?.links[0]?.external) || false;

    return (
        <div className={'draft-tracker-header'}>
            <ConditionalWrapper
                condition={linkTo}
                wrapper={(children) => (
                    <a
                        href={linkTo}
                        target={isLinkInNewTab ? '_blank' : '_self'}
                        rel="noopener noreferrer"
                        className="draft-tracker-header__link"
                    >
                        {children}
                    </a>
                )}
            >
                <div className={`draft-tracker-header__left`}>
                    <div className="draft-tracker-header__left-block">
                        <SvgIcon
                            icon="list-number"
                            className="draft-tracker-header__icon-thematic draft-tracker-header__icon-big"
                        />
                        <h5 className="draft-tracker-header__left-block__title">
                            {title}
                        </h5>
                        <SvgIcon
                            icon="arrow-right"
                            className="draft-tracker-header__icon"
                        />
                    </div>
                </div>
            </ConditionalWrapper>

            <ConditionalWrapper
                condition={sponsorLink}
                wrapper={(children) => (
                    <a
                        href={sponsorLink}
                        target={isSponsorLinkInNewTab ? '_blank' : '_self'}
                        rel="noopener noreferrer"
                        className="draft-tracker-header__link"
                    >
                        {children}
                    </a>
                )}
            >
                <div className="draft-tracker-header__right">
                    <div className="draft-tracker-header__right-block">
                        <span className="draft-tracker-header__right-block__title">
                            {sponsorText}
                        </span>
                        {sponsorImage ? (
                            <div
                                style={{
                                    backgroundImage: `url(${sponsorImage}?height=36)`
                                }}
                                className="draft-tracker-header__right-block__image"
                            />
                        ) : null}
                    </div>
                </div>
            </ConditionalWrapper>
        </div>
    );
};

DraftTrackerHeader.propTypes = {
    title: PropTypes.string,
    linkTo: PropTypes.string,
    isLinkInNewTab: PropTypes.bool,
    promo: PropTypes.object
};
